export class SidebarModelUi {
  public constructor(init?: Partial<SidebarModelUi>) {
    this.sidebarOpen = init && init.sidebarOpen || false;
    this.menuSelected = init && init.menuSelected || '';
  }
  sidebarOpen: boolean;
  menuSelected: string;
}
